const messages = {
    zh: {
        account: {
            account_settings: '账户设置',
            change_email: '更改邮箱',
            change_email_info: '请在下方输入新的邮箱地址。<br>我们会向该邮箱发送一封邮件，请求验证账户。',
            delete_account: '删除账户',
            delete_account_info: {
                header: '该操作将永久性删除您的账户以及您的个人数据。',
                body: '将被删除的数据包括:',
                list: [
                    '您的个人信息',
                    '您在我们系统中申请的工作 (非雇主可能已经下载的数据)',
                    '简历，包括来自雇主的候选人搜索结果',
                    '推广以及职位提醒电子邮件订阅',
                ],
                footer: '此后您可以创建一个新账户。',
            },
            delete_confirmation: '您确定吗？该操作不可撤销。',
            delete_success_title: '对于您的离开，我们感到难过:(',
            delete_success_message: '您的账户已成功删除。现在，您将退出系统。',
            enter_code: '请输入验证码',
            resend_code: '点击此处重新发送验证码',
            reset_password: '重新设置密码',
            reset_password_info: '点击下方按键，我们将向您发送验证码用于重新设置您的密码。之后您将收到提示，创建一个新密码！',
            reset_password_success: '我们已经向您当前的邮箱发送了重置密码的验证码。请同时查看垃圾邮件文件夹以确保查收。点击此处重新发送验证码。',
            try_again: '请在 10 分钟后重试。',
        },

        api_message: {
            UserTokenNotFoundException: '该用户令牌疑似无效。',
            ValidationCaptchaException: '谷歌验证码疑似无效。',
            ValidationException: '某些领域疑似无效。',
            InvalidAuthenticationException: '请检查您的邮箱或密码并重试。',
            MaxAttemptsException: '已超过最大尝试次数。',
            ResourceNotFoundException: '未发现请求。',
            UserNotFoundException: '未发现用户。',
            SeekerNotFoundException: '我们似乎无法识别该邮箱地址。请检查并重试。',
            SeekerEmailResetNotFoundException: '您的重置邮箱地址令牌疑似无效。',
            EmailTokenNotValidException: '该令牌疑似无效。',
            QueryException: '出现异常。',
            ServerErrorException: '出现异常。',
            UserConfirmationTokenNotFoundException: '该令牌疑似无效。',
            UserExistsException: '该邮箱已被使用。',
            JobNotFoundException: '该职位似乎已不存在。',
            UserResumeNotFoundException: '该简历似乎已不存在。',
            UserJobAlertNotFoundException: '该职位提醒似乎已不存在。',
            UserAppliedForJobException: '您似乎已申请了该职位。',
            PromotionNotFoundException: '该推广信息似乎已不存在。',
            SmartfeedJobTokenNotFoundException: '该申请令牌无效。',
            InvalidPasswordException: '您的密码无效。',
            OwnEmailNotAllowedException: '您不能更改至当前邮箱。',
            FileImageSizeException: '该图片太小。图片最小尺寸为150x150px。',
            FileSizeException: '该文件太大。文件最大不得超过20MB',
            GoogleCaptchaException: '无法验证谷歌验证码。',
            SeekerPasswordResetNotFoundException: '请重新输入重置验证码或重试。',
            InvalidFilterCriteria: '范围太广。请设置具体条件。',
            PasswordResetTooManyAttempts: '密码重置操作过于频繁。请在20秒内重试。',
            PasswordTokenNotValid: '密码无效。',
        },

        additional_document: {
            drag_and_drop_info: '拖放或点击<br> 上传您的其它文件！',
            file_type_info: '仅限.docx, .doc, .pdf 文件。',
            max_document_size_info: '简历最大不得超过2MB',
            not_found: '未保存其它文件',
            remove: '删除其它文件?',
            title: '其它文件',
            uploaded: '已上传',
            uploaded_documents: '已上传文件',
        },

        application: {
            title: '申请',
            not_found: '未发现申请',
            view: '查看职位',
        },

        apply: {
            action: '申请该职位',
            apply_with_email_title: '或使用您的电子邮件申请',
            apply_for_job: '申请工作',
            apply_as_guest: '以访客身份申请',
            info: '我们将根据您申请使用的账户自动生成一份个人信息',
            apply_with_email: '使用{邮箱}申请',
            apply_with_linkedin: '使用Linkedin申请',
            back: '返回职位页面',
            confirmation: '确认电子邮件已经发送至',
            job_application: '职位申请',
            loading_resume: '正在加载您的简历。请稍等..',
            success: '感谢您申请该职位',
            title: '用账户申请',
            register_and_apply: '注册并申请',
            application_already_received: '已收到申请',
        },

        cover_letter: {
            add: '添加求职信',
            apply_without: '不添加求职信进行申请',
            drag_and_drop_info: '拖放或点击 <br> 上传您的求职信!',
            edit: '编辑求职信',
            file_type_info: '仅限.docx, .doc, .pdf文件',
            max_document_size_info: '简历最大不超过2MB',
            not_found: '未发现已保存的求职信',
            remove: '删除求职信?',
            title: '求职信',
            uploaded: '已上传',
            uploaded_documents: '已上传求职信',
            write_new: '写一封新的求职信',
        },

        dashboard_menu: {
            applications: '申请',
            saved_jobs: '保存职位',
            job_alerts: '职位提醒',
            profile_details: '个人资料',
            work_preferences: '工作偏好',
            documents: '文件',
            account_settings: '账户设置',
            logout: '退出',
        },

        filter: {
            clear_all: '清空所有内容',
            info: '用户搜索以上内容查找更多',
            see_less: '查看部分',
            see_all_value: '查看所有可选{值}过滤',
        },

        forgot_password: {
            title: '忘记密码',
            info: '请输入您的邮箱，如果帐户存在，我们将向您发送验证码用于重置您的密码。',
            resend_code: '点击此处重新发送验证码',
            success: '我们已经将密码重置验证码发送至以下邮箱。请同时查看垃圾邮件文件夹以确保查收。',
            success_resend_code: '我们已经将密码重置验证码发送至以下邮箱。请同时查看垃圾邮件文件夹以确保查收。',
            try_again: '请在 {countDown} 秒后重试',
        },

        create_password: {
            title: '创建密码',
            info: '欢迎回来! 您的密码似乎已失效。我们已通过电子邮件向您发送了密码重置pin码。请输入您的pin码并在下方重新设置您的密码。',
        },

        global: {
            currency_format: '${0}',
            currency_symbol: '$',
        },

        job_alert: {
            create: '创建职位提醒',
            error: '未能创建您的职位提醒，请刷新并重试。',
            manage: '管理您的职位提醒',
            not_found: '未发现已保存职位提醒',
            remove: '删除该已保存的职位提醒?',
            save: '保存职位提醒',
            saved: '已保存的职位提醒',
            search_term: '搜索词',
            success: '您的职位提醒已创建。谢谢',
            success_remove: '您的职位提醒已删除。谢谢',
            title: '职位提醒',
        },

        job_view: {
            date_posted: '发布日期',
            expired: '该职位已失效',
            expired_desc: 'This job is no longer available. Please view our full list of jobs by clicking \'See more results\'.',
            posted_on: '发布于',
            see_desc: '查看职位内容',
            hide_desc: '隐藏职位内容',
            other_jobs: '其它相似职位',
        },

        single_job: {
            backToSearchUrl: 'jobs',
            see_more_results: '查看更多结果',
            see_more_results_2: '返回所有职位',
        },

        label: {
            add_all: '为您添加所有{值}兴趣',
            add_value: '添加{值}',
            additional_documents: 'Additional documents',
            alert_name: '提醒名称',
            alert_name_placeholder: '输入搜索名称',
            already_have_account: '已有帐户？',
            annualy: '每年',
            annual_salary: '年薪',
            any: 'Any',
            any_value: '任何{值}',
            apply_again: '再次申请',
            apply_as_guest: '以访客身份申请',
            apply_for_this_job: '申请该职位',
            apply_now: '现在申请',
            availability: '有效性',
            back: '返回',
            back_to_value: '返回至{值}',
            base_pay: '基本工资',
            basic_information: 'Basic information',
            cancel: '取消',
            career_level: '职业水平',
            certifications: '证书',
            change_email: '更改邮箱',
            classification: '类别',
            classification_select: '从下面选择分类',
            company: '公司',
            company_placeholder: '输入公司名称，如：ALDI Australia',
            company_size: '公司规模',
            confirm_password: '确认密码',
            confirm_remove: '是，删除',
            consultant: '顾问',
            contact_number: '联系电话',
            contact_number_placeholder: 'Enter contact number',
            continue_to_apply: 'Continue to apply',
            contract_type: '合同类型|合同类型',
            country: 'Country',
            country_of_citizenship: 'Country of citizenship',
            course_name: '课程名称',
            cover_letter: '求职信',
            cover_letter_custom_name: '输入求职信定制名称',
            cover_letter_name: '求职信名称',
            cover_letters: 'Cover letters',
            create: '创建',
            create_job_alert: '创建职位提醒',
            create_password: '创建密码',
            current_role: '当前职位',
            daily: '每日',
            date_posted: '发布日期',
            delete_my_account: '删除我的账户',
            description: '说明',
            desired_occupations: '期望职业',
            desired_pay: '期望薪资',
            desired_work_locations: '期望工作地点',
            dob: '出生日期',
            dont_have_account: '尚未申请账户?',
            download: '下载',
            edit: '编辑',
            edit_value: '编辑{值}',
            education: '教育',
            email: '邮箱',
            email_address: '邮箱地址',
            email_address_placeholder: 'Enter email address',
            email_alert_frequency: '邮件提醒频率',
            email_me_code: '将验证码发送至我的邮箱',
            email_to: '发送至',
            emergency_contact_name: '紧急联络人',
            emergency_contact_number: '紧急联络号码',
            emergency_contact_rel: '紧急联络人关系',
            end_date: '终止日期',
            enter_code: '输入验证码',
            enter_current_password: '输入当前密码',
            enter_current_password_for_email: '输入当前密码以验证邮箱变更',
            enter_new_email: '输入新邮箱',
            enter_new_password: '输入新密码',
            enter_the_value: '输入{值}',
            enter_value: '输入{值}',
            enter_your_value: '输入您的{值}',
            enter_your_value_again: '再次输入您的{值}',
            expires_at: 'Closing date',
            filters: '过滤',
            find_jobs_now: 'Find jobs now',
            first_name: '名',
            first_name_placeholder: 'Enter first name',
            forgot_password: '忘记密码',
            frequency: '频率',
            gender: '性别',
            go: '继续',
            home_location: '住址',
            hourly: '每小时',
            hourly_rate: '时薪',
            in_progress: '进行中',
            industries: '您希望从事的行业',
            institution_name: '机构名称',
            is_contactable: 'May we contact this referee?',
            is_report_directly: 'Did you report directly to this referee?',
            job_mode: '工作模式',
            job_title: '职位名称',
            job_title_placeholder: '输入您的职位名称，如：会计',
            job_type: '职位类型|职位类型',
            job_type_placeholder: '选择一种职位类型',
            keyword: '关键词|关键词',
            languages: '语言',
            last_name: '姓',
            last_name_placeholder: 'Enter last name',
            licenses_and_certifications: '许可和证书',
            licenses_or_certifications: '许可或证书',
            location: '位置',
            login: '登录',
            look_for_all_jobs: '寻找所有可用的工作',
            max: '最多',
            message: '消息',
            min: '最少',
            mobile_number: 'Mobile number',
            mobile_number_placeholder: 'Enter mobile number',
            modified: '修改',
            new_cover_letter_details: '新求职信详情',
            not_added_value: '无{值}添加',
            not_found: '未发现',
            no_industries: '我没有行业偏好',
            no_job_mode: '我没有工作模式偏好',
            null_pay_included: '包括没有工资详细信息的工作',
            occupation: '职业',
            occupation_placeholder: '为您添加所有感兴趣的职业',
            off: '离开',
            password: '密码',
            payband_placehoder: '选择最接近的数值',
            perks_and_benefits: '津贴和福利',
            per_day: '每天',
            phone_number: 'Phone number',
            phone_number_placeholder: 'Enter phone number',
            placeholder_email: 'email',
            placeholder_password: 'password',
            position: 'Position',
            position_placeholder: 'Enter position',
            print: '打印',
            profession: '职业',
            profile_picture: '个人照片',
            qualification_type: '资格类型',
            range: '范围',
            recover_password: '恢复密码',
            reference: '参考',
            reference_number: '参考编号',
            register: '注册',
            register_and_apply: '注册并申请',
            relevance: '相关',
            remove: '删除',
            required_value: '该{值}领域为必填',
            reset: '重置',
            reset_password: '重置密码',
            resumes: '简历',
            salary: '薪资',
            salary_type: '薪资类型',
            salary_currency: '工资货币',
            salary_any_currency: '任何货币',
            save: '保存',
            save_cover_letter: '保存求职信',
            save_job: '保存职位',
            save_value: '保存{值}',
            save_work_experience: '保存工作经历',
            search_by_location: '按郊区、城市或区域搜索',
            search_jobs: '搜索职位',
            search_keyword: '搜索关键词',
            search_within_value: '`在{值1} {值2}之间搜索',
            sector: '部门',
            select_location: '所有地点',
            select_value: '选择{值}',
            share: 'Share',
            sign_in: '登陆',
            sign_in_and_apply: '登录并申请',
            skills: '技能',
            sort_by: '分类根据',
            start_date: '开始日期',
            start_end_dates: '开始和结束日期',
            suburb_city_area: '郊区、城市、或地区',
            sub_classification: '次级分类',
            sub_classification_select: '选择子分类',
            submit: '提交',
            unsave: '未保存',
            upload_file_size: 'File size 5MB max',
            upload_label: 'Tap to upload document',
            upload_new: 'Upload new',
            upload_new_additional_document: '上传新附加文件',
            upload_new_cover_letter: '上传新求职信',
            upload_new_resume: '上传新简历',
            upload_profile_picture: '上传个人照片',
            uploaded: 'Uploaded',
            uploaded_document: 'Uploaded document',
            uploaded_now: 'just now',
            view_job: '查看职位',
            weekly: '每周',
            what_is_this: '这是什么',
            what_is_this_occupation: '我们将根据这个职业为您量身定制职位推荐信。请选择与该职别最相关的职业。',
            work_authorisation: '工作许可',
            work_experience: '工作经验',
            work_location: '工作地点',
            work_occupation_placeholder: '输入您的工作职业',
            work_preferences: '工作偏好',
            work_type: '工作类型',
            write_a_cover_letter: '撰写求职信',
            write_cover_letter: '撰写求职信',
        },

        login: {
            welcome_back: '欢迎回来',
            welcome: '欢迎！',
            title: '登录',
            info: '',
            back: '回到登入',
        },

        profile: {
            basic_information: '基本信息',
            not_found_location: '我们目前不支持此位置的职位列表。请联系我们请求新的位置。',
            not_found_global_location: '找不到匹配的位置。请尝试不同的搜索或选择国家作为位置。',
            pay_info: '您的薪资信息有助于我们进一步了解您的职业经历，从而关注您的职业发展道路。',
            profile_details: '个人资料',
        },

        register: {
            welcome: '欢迎',
            welcome_aboard: '欢迎加入',
            info: '在几秒钟内创建一个账户',
            back: '返回登陆',
        },

        reset_email: {
            title: '重置邮箱',
            success: '您的邮箱已重置',
        },

        reset_password: {
            title: '创建密码',
            info: '请输入您的账户邮箱和新密码。',
            success: '您已成功创建新密码!',
        },

        resume: {
            apply_without: '不添加简历申请',
            default: '默认简历',
            dropbox_title: '通过Dropbox上传',
            default_option: '制作该默认简历',
            default_text: '选择简历可选项',
            drag_and_drop_info: '拖放或点击<br>上传您的简历!',
            drag_and_drop_size: '(文件最大不超过2MB)',
            file_type_info: '仅限.docx, .doc, .pdf, .rtf, .txt, .odt, .pages文件',
            googledrive_title: '通过Google Drive上传',
            max_resume_size_info: '简历最大不超过2MB',
            new: '上传新简历',
            not_found: '未发现已上传简历',
            remove: '删除简历?',
            title: '简历',
            upload_documents: '上传文件',
            upload: '上传简历',
            uploaded: '已上传',
            uploaded_resumes: '已上传简历',
            upload_via: '通过{服务}上传',
            ducment_uploaded: '文件上传',
        },

        saved_job: {
            saved_jobs: '保存职位',
            not_found: '未发现已保存职位',
        },

        search_results: {
            not_found: '对不起，未能发现符合该搜索条件的职位。',
            showing: '顯示第',
            separator: '-',
            of: '的',
            results: '結果',
            listView: '列表顯示',
            mapView: '地圖視圖',
            mapViewLocation: '街道地址/郵政編碼',
            mapViewRadius: '以內（公里',
            mapViewUpdate: '更新地圖',
            mapViewReset: '重置地圖',
        },

        share: {
            facebook: '脸书',
            linkedin: '领英',
            title: '通过分享',
            twitter: '推特',
        },

        terms: {
            link: '同意我们的 以继续',
            terms: '使用条款',
            and: '以及',
            privacy: '隐私政策',
            validation_message: '请同意我们的条款和条件',
        },

        work_preferences: {
            work_preferences: '工作偏好',
            next_role: '您的下一个职位',
            other: '其它偏好',
            job_type: 'Job Type',
            contract_type: 'Contract Type',
        },

        work_experience: {
            add: '添加工作经验?',
            edit: '编辑工作经验?',
            remove: '删除工作经验?',
        },

        education: {
            add: '添加教育',
            remove: '删除教育',
        },

        reference: {
            add: '添加裁判',
            remove: '移除裁判',
        },

        screening: {
            confirm_and_finish: '确认并完成',
            title: '完成附加问题',
            sub_title: '通过完成以下问题来提高您被考虑担任这份工作的机会',
        },

        searchbar: {
            keywords_label: '關鍵字',
            classifications_label: '職缺類別',
            classification_placeholder: '在所有分类中',
            locations_label: '地点',
        },

        networks: {
            facebook: {
                shareText: '郵政',
            },
            twitter: {
                shareText: '鳴叫',
            },
            linkedin: {
                shareText: '分享',
            },
        },
    },
};

export default messages;
